import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from './auth'

export const containersApi = createApi({
  baseQuery: baseQuery(),
  reducerPath: 'containersApi',
  endpoints: (builder) => ({
    getContainers: builder.query<ContainerDictionary[], void>({
      query: () => 'dictionary/v2.0/containers/',
    }),
  }),
})

export const { useGetContainersQuery, useLazyGetContainersQuery } = containersApi
